module.exports = __webpack_public_path__ + "assets/img/1.0c7a1f81.jpg";